<sl-grid>
  <sl-column [startColumn]="1" [endColumn]="12">
    <section id="breadcrumbNav" class="breadcrumb-nav">
      <ng-container *ngFor="let breadcrumb of breadcrumbs$ | async; let last = last">
        @if (breadcrumb.url !== '/home' && breadcrumb.url !== '/login') {
        <div class="breadcrumb">
          <sl-link text="Home" link="/home"></sl-link>
          <span class="material-symbols-outlined">arrow_forward_ios</span>
          @if (last) {
          <span
            ><sl-typography
              variant="body-20"
              weight="regular"
              color="var(--color-neutral-55)"
              [text]="breadcrumb.label"
            ></sl-typography
          ></span>
          } @else {
          <sl-link [text]="breadcrumb.label" [link]="breadcrumb.url"></sl-link>
          }
        </div>
        }
      </ng-container>
    </section>
  </sl-column>
</sl-grid>
